import PropTypes from "prop-types";
import React,{useState} from "react";
import bannerData from "../../data/banner/banner-one.json";
import BannerOneSingle from "../../components/banner/BannerOneSingle.js";
import { getBanner, getCaption, getCover } from "../../Services/API/Get";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner";

const BannerOne = ({ spaceTopClass, spaceBottomClass }) => {

  const [caption, setcaption] = useState([]);
  const [lopen, setlopen] = useState(false);

  const captionGet = () => {
    setlopen(true);
    getBanner()
    .then((res) => {
      setlopen(false);
      console.log("about>>",res.data);
      setcaption(res.data);
      // setLogo(res.data[res.data.length - 1].image)
      // this.setState({
      //   logo: res.data[res.data.length - 1].image,
      // });
    })
    .catch((error) => {
      setlopen(false);
      console.error(error);
    });
  };

  const coverGet = () => {
    setlopen(true);
    getCover()
    .then((res) => {
      setlopen(false);
      console.log("about>>",res.data);
      setcaption(res.data);
      // setLogo(res.data[res.data.length - 1].image)
      // this.setState({
      //   logo: res.data[res.data.length - 1].image,
      // });
    })
    .catch((error) => {
      setlopen(false);
      console.error(error);
    });
  };

  React.useEffect(() => {
    captionGet();
    // coverGet();
  }, []);
  return (
    <>
        <LoadingSpinner open={lopen} />
    <div
      className={`banner-area ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <div className="row" style={{display:"flex",justifyContent:"center"}} >
          {caption &&
            caption.map((single, key) => {
              return (
                <BannerOneSingle
                  data={single}
                  key={key}
                  spaceBottomClass="mb-30"
                />
              );
            })}
        </div>
      </div>
    </div>
    </>
  );
};

BannerOne.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default BannerOne;
